const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const normalizeEmail = (value: string) => value.trim().toLowerCase();

export const isValidEmail = (value: string) =>
  EMAIL_REGEX.test(normalizeEmail(value));

// A API só aceita senhas numéricas de 6 a 15 dígitos
export const isValidPassword = (value: string) => /^\d{6,15}$/.test(value);
